export const GET_SEARCHED_MESSAGES = 'GET_SEARCHED_MESSAGES';
export const GET_NEXT_SEARCHED_MESSAGES = 'GET_NEXT_SEARCHED_MESSAGES';
export const START_MESSAGE_SEARCH = 'START_MESSAGE_SEARCH';
export const START_GETTING_SEARCHED_MESSAGES = 'START_GETTING_SEARCHED_MESSAGES';
export const SET_QUERY_INVALID = 'SET_QUERY_INVALID';

export const SET_CURRENT_CHANNEL = 'SET_CURRENT_CHANNEL';
export const CHANNEL_INVALID = 'CHANNEL_INVALID';
